import '../Scss/main.scss';

// ── Smooth Scroll mit Nav-Offset ────────────────────────────
document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href^="#"]');
  if (!link) return;

  const id = link.getAttribute('href').slice(1);
  if (!id) return;

  const target = document.getElementById(id);
  if (!target) return;

  e.preventDefault();

  const nav = document.querySelector('.site-nav');
  const navHeight = nav ? nav.getBoundingClientRect().height : 0;
  const top = target.getBoundingClientRect().top + window.scrollY - navHeight;

  window.scrollTo({ top, behavior: 'smooth' });
});

// ── Module Loader ────────────────────────────────────────────
const modules = import.meta.glob('./Modules/*.js');

document.querySelectorAll('[data-module]').forEach(async (element) => {
  const name = element.dataset.module;
  const loader = modules[`./Modules/${name}.js`];

  if (!loader) {
    console.warn(`Module not found: ${name}`);
    return;
  }

  const mod = await loader();

  if (typeof mod.default === 'function') {
    mod.default(element);
  }
});